import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import {utils} from '../utils/utils';
import {MatSnackBar,MatDialog} from '@angular/material';
import { DataService } from '../utils/data.service';
import { modalComponent } from '../utils/modal/modal.component';
import { catchError, map } from 'rxjs/operators';
import { DatosGeneralesSAE } from '../datos-generales-SAE';
import { Observable, Subject } from 'rxjs';


@Injectable()
export class generalService{
	//public usuario:Array<any>;
	public datosGeneralesSAE: any;
	public _utils:utils;
	public headers = new Headers({'Content-Type': 'application/json; charset=utf-8', 'Accept': 'application/json, text/javascript, /;'});
	public headersMulti = new Headers({'Content-Type': 'multipart/form-data; charset=utf-8', 'Accept': 'application/json, text/javascript, /;'});

	constructor(public snackBar: MatSnackBar,
				private _http:Http,
				public dataService: DataService, 
				public dialog: MatDialog){
		this._utils = new utils();
		this.datosGeneralesSAE = DatosGeneralesSAE;
	}

	//general
	metodoCallParams(datos:any, webServ:string, showLoadingScreen = false){
		let json = JSON.stringify(datos);
		let params = json;
		if(showLoadingScreen) {
			this.datosGeneralesSAE.showSpinnerLoading = showLoadingScreen;
		}
		return this._http.post(this._utils.url + webServ, params, {headers: this.headers}).pipe(
			map(res => {
				if(showLoadingScreen) {
					this.datosGeneralesSAE.showSpinnerLoading = false;
				}
				return res.json();
			}),
			catchError(this.handleError.bind(this))
		);
	}

	//headersMulti

	metodoCallParamsMulti(datos:any, webServ:string, showLoadingScreen = false){
		if(showLoadingScreen) {
			this.datosGeneralesSAE.showSpinnerLoading = showLoadingScreen;
		}
		return this._http.post(this._utils.url + webServ, datos).pipe(
			map(res => {
				if(showLoadingScreen) {
					this.datosGeneralesSAE.showSpinnerLoading = false;
				}
				return res.json();
			}),
			catchError(this.handleError.bind(this))
		);
	}

	metodoCallParamsPutPost(tipo:any, datos:any, webServ:string, showLoadingScreen = false){
		if(showLoadingScreen) {
			this.datosGeneralesSAE.showSpinnerLoading = showLoadingScreen;
		}
		let json = JSON.stringify(datos);
		let params = json;
		if(tipo == "agregar")
		{
			return this._http.post(this._utils.url+webServ, params, {headers: this.headers}).map(res => {
				if(showLoadingScreen) {
					this.datosGeneralesSAE.showSpinnerLoading = false;
				}
				return res.json();
			});
		}
		else{
			return this._http.put(this._utils.url+webServ, params, {headers: this.headers}).map(res => {
				if(showLoadingScreen) {
					this.datosGeneralesSAE.showSpinnerLoading = false;
				}
				return res.json();
			});
		}
	}

	metodoCall(webServ:string, showLoadingScreen = false) {
		if(showLoadingScreen) {
			this.datosGeneralesSAE.showSpinnerLoading = showLoadingScreen;
		}
		return this._http.get(this._utils.url+webServ).pipe(
			map(res => {
				if(showLoadingScreen) {
					this.datosGeneralesSAE.showSpinnerLoading = false;
				}
				return res.json();
			}),
			catchError(this.handleError.bind(this))
		);
	}

	toastCall(mensaje){
		this._utils.toast(mensaje,this.snackBar);
	}

	modal(eliminarHttp, tipo, mensaje, webServ, objecto){
	    this.dataService.modal = tipo;
	    this.dataService.mensaje = mensaje;
	    const dialogRef = this.dialog.open(modalComponent, {disableClose: true});
	    this.dataService.dialogRef = dialogRef;
	    dialogRef.afterClosed().subscribe((result) => {
	      if(this.dataService.guardado){
	          this.eliminar({eliminarHttp, tipo, mensaje, webServ, objecto});
	      }
	    });
  	}

  	eliminar({eliminarHttp, tipo, mensaje, webServ, objecto}){
	    this.metodoCallParams(objecto, webServ).subscribe(
	        result => {
	          if(result!=""){
	        		eliminarHttp.emit(result);
	        	}
	        	else{
	        		this.toastCall("El registro se eliminó exitosamente!");
	          		eliminarHttp.emit(result);
	        	}
	        },
	        error => {
	          var errorMsj = <any>error;
	          console.log(errorMsj);
	        }
	    );
	}

	handleError(error) {
		this.datosGeneralesSAE.showSpinnerLoading = false;

		let msg = 'Ocurrio un error inesperado.'
		error = JSON.parse(error._body);		
		
		if (error['ExceptionMessage']) {
			msg = error.ExceptionMessage;
		}
		
		this.toastCall(msg)
	}



	// ------------------------------------- HTTP FUNCTION -------------------------------------
	
	//CONSULTAR

	// Función utilizada cuando se consulta información de la base de datos, si se necesita enviar un parámetro se tiene 
	// que enviar mediante url.
	// * Ver el apartado de NOTAS
	requestGet(webServ: string){
		return this._http.get(this._utils.url + webServ).pipe(
			map(res => res.json()),
			catchError(this.handleError.bind(this))
		);
	}

	//AGREGAR

	// Se utiliza está función cuando se necesita ingresar un registro en base de datos y los parámetros que se envían
	// se pueden enviar por url.
	// * Ver el apartado de NOTAS
	requestPost(webServ: string){
		return this._http.post(this._utils.url + webServ, "", {headers: this.headers}).map(res => res.json());
	}

	// Se utiliza está función cuando se necesita ingresar un registro en base de datos y los parámetros necesitan ir 
	// en el body
	requestPostParams(datos: any, webServ: string){
		let json = JSON.stringify(datos);
		let params = json;
		return this._http.post(this._utils.url + webServ, params, {headers: this.headers}).map(res => res.json());
	}

	//EDITAR

	// Se utiliza esta función cuando se necesita editar un registro en base de datos y los parámetros necesarios se 
	// pueden enviar por url.
	// * Ver el apartado de NOTAS
	requestPut(webServ: string){
		return this._http.put(this._utils.url + webServ, "", {headers: this.headers}).map(res => res.json());
	}

	// Se utiliza esta función cuando se necesita editar un registro en base de datos y los parámetros se necesitan enviar
	// en el body
	requestPutParams(datos: any, webServ: string){
		let json = JSON.stringify(datos);
		let params = json;
		return this._http.put(this._utils.url + webServ, params, {headers: this.headers}).map(res => res.json());
	}

	//ELIMINAR

	// Se utiliza esta función cuando se necesita eliminar un registro de la base de datos, los parámetros tienen que 
	// enviarse mediante url. 
	// * Ver el apartado de NOTAS
	requestDelete(webServ: string){
		return this._http.delete(this._utils.url + webServ).pipe(
			map(res => res.json()),
			catchError(this.handleError.bind(this))
		);
	}


	// ------------------------------------- NOTAS -------------------------------------
	// Los parámetros que van mediante url deben de ir separados por un & ej: "?id=1&email=mrs@mrs.com&name=mrs" o si son muchos se puede enviar un 
	// json como string; en el back se recibe y se transforma a un objeto para poder manipular los datos.
	// El limite que puede tener la url con todo y parámetros es de 2000 caracteres (depende del navegador).


	private subject = new Subject<any>();

	sendClickEvent() {
		this.subject.next();	}

	getClickEvent(): Observable<any>{ 
		return this.subject.asObservable();	}

}


// WEBPACK FOOTER //
// ./src/app/services/general.service.ts